<template>
  <div class="conventional-dashboard-shell">
    <div class="dash-page-wrapper conventional-dash-layout">
      <DashboardList ref="reloadDashboards" @selected-dashboard="handleselectedDashboard" />
      <div class="dash-main-column">
        <div class="conventional-dashboard-toolbar">
          <DashboardModeSwitch variant="solid" />
        </div>
        <DashboardView :selectedDashboard="selectedDashboard" @dashboard-delete="reloadDashboards"/>
      </div>
    </div>
  </div>
  </template>
        
    <script>
  import DashboardList from '@/components/layout/DashboardNew/DashboardList.vue';
  import DashboardView from '@/components/layout/DashboardNew/DashboardView.vue';
  import DashboardModeSwitch from '@/components/layout/Dashboard/DashboardModeSwitch.vue';
  export default {
    components: { DashboardList, DashboardView, DashboardModeSwitch },
    name: "List",
    data() {
      return {
        selectedDashboard: {},
      }
    },
    methods: {
      handleselectedDashboard (dashboard) {
this.selectedDashboard = dashboard
      },
      reloadDashboards() {
        this.selectedDashboard = {};
      this.$refs.reloadDashboards.getSavedDashboards();
    },
    },
  };
  </script>

<style scoped>
.conventional-dashboard-shell {
  height: calc(100vh - 65px);
}

.conventional-dashboard-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 0 0;
  flex-shrink: 0;
}
</style>